import { Box } from "@mui/material"
import { handleEsc } from "common/closeOnEscape"
import CustomPagination from "common/CustomPagination"
import { FilterExportToolbar } from "common/FilertExportToolbar"
import { CreatePricingRuleModal } from "company/showTabs/companyModals/CreatePricing"
import { EditPricingRuleModal } from "company/showTabs/companyModals/EditPricing"
import ActionButton from "components/ActionButton"
import React from "react"
import { List, RaRecord } from "react-admin"
import UserService from "UserService"
import { PricingRulesDatagrid } from "./PricingRulesDatagrid"

interface PricingRuleListProps {
  type: "DYNAMIC" | "FIXED"
}

const PricingRuleList = ({ type }: PricingRuleListProps) => {
  const [open, setOpen] = React.useState<{ type: "EDIT" | "CREATE"; record?: RaRecord } | undefined>(undefined)

  const close = () => {
    setOpen(undefined)
  }

  React.useEffect(handleEsc(close), [])

  const createBoundle = open?.type === "CREATE" && (
    <CreatePricingRuleModal record={open.record} open={open.type === "CREATE"} onClose={close} type={type} />
  )
  const editBoundle = open?.type === "EDIT" && open.record && (
    <EditPricingRuleModal record={open.record} open={open.type === "EDIT"} onClose={close} />
  )

  return (
    <Box margin="0px 60px">
      {open && editBoundle}
      {open && createBoundle}

      <List
        perPage={50}
        sort={{ field: "name", order: "DESC" }}
        exporter={false}
        pagination={<CustomPagination />}
        actions={
          <FilterExportToolbar
            right={
              <>
                {UserService.hasRoles(["ROLE_PLATFORM_MANAGER"]) && (
                  <ActionButton
                    onClick={() => {
                      setOpen({ type: "CREATE", record: undefined })
                    }}
                  >
                    Create
                  </ActionButton>
                )}
              </>
            }
          />
        }
        className="assigments-datagrid"
      >
        <PricingRulesDatagrid type={type} onEdit={(record) => setOpen({ type: "EDIT", record })} />
      </List>
    </Box>
  )
}

export default React.memo(PricingRuleList)
